class FeaturedBlogs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSwiper();
  }

  async initSwiper() {
    new Swiper(this.querySelector('.featured-blogs__swiper'), {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: true,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
}

customElements.define('featured-blogs', FeaturedBlogs);
